<div class="not-found-page">
  <div class="inner-content">
    <h2 class="header">{{'mmi.fallback_title' | translate}}</h2>
    <p class="message">{{'mmi.fallback_message.part_1' | translate}}<a (click)="navigateToLoginPage($event)" href="javascript:void(0)">{{'mmi.fallback_message.link' | translate}}</a>{{'mmi.fallback_message.part_2' | translate}}</p>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/mmi/not-found-page/not-found-page.component.html